import React, { useMemo, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

const FeatureFlagContext = createContext();

export const useFeatureFlag = () => useContext(FeatureFlagContext);

export const FeatureFlagProvider = ({ flag, children }) => {
  const value = useMemo(
    () => {
      const hideAddInstruction = _get(flag, 'hideAddInstruction', false);
      const hideCallAndChat = _get(flag, 'hideCallAndChat', false);
      const hidePhoto = _get(flag, 'hidePhoto', false);
      const hideCashlessPOD = _get(flag, 'hideCashlessPOD', false);
      return {
        hideAddInstruction,
        hideCallAndChat,
        hidePhoto,
        hideCashlessPOD,
      };
    },
    [
      flag.hideCallAndChat,
      flag.hideAddInstruction,
      flag.hidePhoto,
      flag.hideCashlessPOD,
    ],
  );

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

FeatureFlagProvider.propTypes = {
  flag: PropTypes.shape({
    hideAddInstruction: PropTypes.bool,
    hideCallAndChat: PropTypes.bool,
    hidePhoto: PropTypes.bool,
    hideCashlessPOD: PropTypes.bool,
  }),
  children: PropTypes.node,
};

FeatureFlagProvider.defaultProps = {
  flag: {
    hideAddInstruction: false,
    hideCallAndChat: false,
    hidePhoto: false,
    hideCashlessPOD: false,
  },
  children: null,
};

export default {};
